import { Box } from "@mui/material"
import React, { useMemo } from "react"

import BankDetailsField from "./methods/BankDetailsField"

import type { CompanyPaymentType, CompanyPaymentTypeMethod, CompanyStatus } from "@/graphql/codegen/graphql"

interface BankPaymentFieldsProps {
  paymentType: CompanyPaymentType
  onDelete: (methodIdToDelete?: string) => void
  onDefaultChange?: (paymentMethod: CompanyPaymentTypeMethod, paymentType: CompanyPaymentType) => void
  onRefetch?: () => void
  onToggleActivation: (methodId: string, currentStatus: CompanyStatus) => void
}

const BankPaymentFields: React.FC<BankPaymentFieldsProps> = ({
  paymentType,
  onDelete,
  onDefaultChange,
  onRefetch,
  onToggleActivation,
}) => {
  const methods = paymentType.paymentMethods!

  const sortedMethods = useMemo(() => {
    const sortedMethods = [...methods]
    sortedMethods.sort((a, b) => a!.companyPaymentMethodId.localeCompare(b!.companyPaymentMethodId))
    return sortedMethods
  }, [methods])

  return (
    <Box className='space-y-4'>
      {sortedMethods.map((method) => (
        <BankDetailsField
          key={method!.companyPaymentMethodId}
          method={method!}
          onDefaultChange={() => onDefaultChange?.(method!, paymentType)}
          onRefetch={onRefetch}
          onDelete={onDelete}
          onToggleActivation={onToggleActivation}
        />
      ))}
    </Box>
  )
}

export default BankPaymentFields
